export default "__VITE_ASSET__BBSX6EuM__"